export default "__VITE_ASSET__CIpTte2f__"